export default __webpack_public_path__ + "df23db92b8c0be82492d0001ebf894bb.woff";